import { Link } from "@tanstack/react-router";
import { Phone, Mail, MapPin, ShieldCheck, Clock, Facebook } from "lucide-react";
import { BUSINESS, SERVICES, CITIES } from "./constants";
import { BBBSeal } from "./BBBSeal";

export function Footer() {
  return (
    <footer className="storm-bg text-brand-foreground mt-16">
      <div className="mx-auto max-w-7xl px-4 py-12 grid gap-10 md:grid-cols-5">
        <div>
          <div className="font-display font-bold text-2xl">Destination Roofing Inc.</div>
          <p className="mt-3 text-sm opacity-90">
            Family-owned, licensed and insured roofing contractor serving Citrus County, FL and surrounding areas.
          </p>
          <div className="mt-4 space-y-2 text-sm">
            <a href={BUSINESS.phoneHref} className="flex items-center gap-2 hover:text-cta">
              <Phone className="size-4" /> {BUSINESS.phone}
            </a>
            <a href={BUSINESS.emailHref} className="flex items-center gap-2 hover:text-cta break-all">
              <Mail className="size-4 shrink-0" /> {BUSINESS.email}
            </a>
            <div className="flex items-start gap-2 opacity-90">
              <MapPin className="size-4 mt-0.5 shrink-0" />
              <span>{BUSINESS.serviceArea}</span>
            </div>
            <div className="flex items-start gap-2 opacity-90">
              <Clock className="size-4 mt-0.5 shrink-0" />
              <div>
                <div>Mon–Sat: 6:30 AM – 5:00 PM</div>
                <div>Sun: Closed</div>
                <div className="text-xs mt-1 text-cta">After-hours emergency response available</div>
              </div>
            </div>
            <div className="flex items-center gap-2 opacity-90">
              <ShieldCheck className="size-4" /> {BUSINESS.license}
            </div>
          </div>
          <div className="mt-4">
            <div className="text-xs font-semibold mb-1 opacity-90">BBB Accredited Business</div>
            <BBBSeal />
          </div>
          <a
            href={BUSINESS.facebook}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 hover:text-cta pt-1 text-sm"
          >
            <Facebook className="size-4" /> Follow on Facebook
          </a>
        </div>

        <div>
          <div className="font-semibold mb-3">Services</div>
          <ul className="space-y-2 text-sm opacity-90">
            {SERVICES.map(s => (
              <li key={s.slug}><Link to={s.slug} className="hover:text-cta">{s.title}</Link></li>
            ))}
          </ul>
        </div>

        <div>
          <div className="font-semibold mb-3">Service Areas</div>
          <ul className="space-y-2 text-sm opacity-90">
            {CITIES.map(c => (
              <li key={c.slug}><Link to={c.slug} className="hover:text-cta">{c.city}, {c.state}</Link></li>
            ))}
            <li><Link to="/service-areas" className="hover:text-cta font-semibold">All service areas →</Link></li>
          </ul>
        </div>

        <div>
          <div className="font-semibold mb-3">Company</div>
          <ul className="space-y-2 text-sm opacity-90">
            <li><Link to="/about" className="hover:text-cta">About Destination Roofing</Link></li>
            <li><Link to="/blog" className="hover:text-cta">Roofing Blog</Link></li>
            <li><Link to="/atlas-shingle-colors" className="hover:text-cta">Atlas Shingle Colors</Link></li>
            <li><Link to="/projects" className="hover:text-cta">Roofing Projects</Link></li>
            <li><Link to="/gallery" className="hover:text-cta">Project Gallery</Link></li>
            <li><Link to="/reviews" className="hover:text-cta">Reviews</Link></li>
            <li><Link to="/contact" className="hover:text-cta">Contact</Link></li>
          </ul>
          <a href={BUSINESS.phoneHref} className="btn-cta mt-5 w-full text-sm">
            <Phone className="size-4" /> Call Now
          </a>
        </div>

        <div>
          <div className="font-semibold mb-3">Guides</div>
          <ul className="space-y-2 text-sm opacity-90">
            <li><Link to="/florida-roof-insurance-rules" className="hover:text-cta">Florida Roof Insurance & Code Rules</Link></li>
            <li><Link to="/citrus-county-roof-permits" className="hover:text-cta">Citrus County Roof Permits</Link></li>
            <li><Link to="/roof-cost-citrus-county" className="hover:text-cta">Roof Cost in Citrus County</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="mx-auto max-w-7xl px-4 py-5 text-xs opacity-80 flex flex-col md:flex-row items-center justify-between gap-2">
          <div>© {new Date().getFullYear()} Destination Roofing Inc. All rights reserved.</div>
          <div>{BUSINESS.license} · Licensed & Insured · {BUSINESS.atlasCredential}</div>
        </div>
      </div>
    </footer>
  );
}
